import {
  DealerLocatorServicesOffered,
  DealerLocatorStoreContactInfo,
  DealerLocatorStoreHoursInfo,
  DealerStore,
  DrawerBody
} from '@cat-ecom/pcc-components';
import { DealerLocatorSearchResult } from '../dealer-locator-search-results';
interface DealerLocatorStoreDetailsDrawerBodyProps {
  selectedStoreObjDrawer: DealerStore;
  unitOfMeasure: 'mi' | 'km';
  closestLabel: string;
  isStoreLocationListViewUpdateFlag: boolean;
  isStoreLocationMapViewUpdateFlag: boolean;
  isStoreLocationOptimizationFlag: boolean;
  contactInfoDrivingDirectionsLabel: string;
  contactInfoEmailLabel: string;
  contactInfoTitle: string;
  contactInfoWebsiteLabel: string;
  returnContactUrl: (storeId?: string) => string;
  servicesOfferedTitle: string;
  storeHoursOpen24HrsTitle: string;
  storeHoursTitle: string;
}

export const DealerLocatorStoreDetailsDrawerBody = ({
  selectedStoreObjDrawer,
  unitOfMeasure,
  closestLabel,
  isStoreLocationListViewUpdateFlag,
  isStoreLocationMapViewUpdateFlag,
  isStoreLocationOptimizationFlag,
  contactInfoDrivingDirectionsLabel,
  contactInfoEmailLabel,
  contactInfoTitle,
  contactInfoWebsiteLabel,
  returnContactUrl,
  servicesOfferedTitle,
  storeHoursOpen24HrsTitle,
  storeHoursTitle
}: DealerLocatorStoreDetailsDrawerBodyProps) => {
  return (
    <DrawerBody>
      <DealerLocatorSearchResult
        isDisabled={false}
        unitOfMeasure={unitOfMeasure}
        store={selectedStoreObjDrawer}
        closestLabel={closestLabel}
        isStoreLocationListViewUpdateFlag={isStoreLocationListViewUpdateFlag}
        isStoreLocationMapViewUpdateFlag={isStoreLocationMapViewUpdateFlag}
        isStoreLocationOptimizationFlag={isStoreLocationOptimizationFlag}
        forStoreDetailsDrawer={true}
      />
      <DealerLocatorStoreContactInfo
        contactInfoDrivingDirectionsLabel={contactInfoDrivingDirectionsLabel}
        contactInfoEmailLabel={contactInfoEmailLabel}
        contactInfoTitle={contactInfoTitle}
        contactInfoWebsiteLabel={contactInfoWebsiteLabel}
        returnContactUrl={returnContactUrl}
        store={selectedStoreObjDrawer}
        isStoreLocationOptimizationFlag={isStoreLocationOptimizationFlag}
      />
      <DealerLocatorServicesOffered
        servicesOfferedTitle={servicesOfferedTitle}
        store={selectedStoreObjDrawer}
        isStoreLocationOptimizationFlag={isStoreLocationOptimizationFlag}
      />
      <DealerLocatorStoreHoursInfo
        store={selectedStoreObjDrawer}
        storeHoursOpen24HrsTitle={storeHoursOpen24HrsTitle}
        storeHoursTitle={storeHoursTitle}
        isStoreLocationOptimizationFlag={isStoreLocationOptimizationFlag}
      />
    </DrawerBody>
  );
};
